import { Link, Stack, Theme, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AdjusterInfo } from '../../../types/type';
import { getPrettyPhoneNumber, getShortName } from '../../../utils/Utilities';

interface ClaimActivityInfo {
  headerText: string;
  adjusterInfo: AdjusterInfo;
}

export default function AdjusterInfoCard(props: ClaimActivityInfo) {
  const navigate = useNavigate();
  function handleEmailClick() {
    navigate('/adjuster-contact');
  }

  const theme: Theme = useTheme();
  const circleStyle = {
    height: '61px',
    width: '61px',
    backgroundColor: theme.custom.colors.accordionChevronColor,
    borderRadius: '50%',
    marginTop: '-3.5rem',
  };
  const cardStyling = {
    borderRadius: theme.custom.styles.adjusterCardPhoneNumberAndEmailCardStyle.borderRadius,
    marginTop: '1rem',
    border: theme.custom.styles.adjusterCardPhoneNumberAndEmailCardStyle.border,
    borderColor: theme.custom.styles.adjusterCardPhoneNumberAndEmailCardStyle.borderColor,
  };
  const lineStyle = {
    border: '.5px solid',
    zIndex: '-1',
    marginTop: '3.5rem',
  };

  return (
    <Stack sx={{ marginTop: '1rem' }}>
      <Typography sx={theme.custom.styles.confirmationSubHeader}>{props.headerText}</Typography>

      <Stack direction="column" sx={cardStyling}>
        <hr
          style={{
            ...lineStyle,
            borderColor: theme.custom.colors.footerTopBorderColor,
          }}
        ></hr>
        <Stack sx={{ padding: '1rem' }}>
          {props.adjusterInfo.adjusterName && (
            <span style={circleStyle}>
              <Typography
                sx={{
                  ...theme.custom.styles.adjusterShortNameStyle,
                  marginLeft: '0.8rem',
                  marginBottom: '0.8rem',
                  marginTop: '0.8rem',
                }}
              >
                {getShortName(props.adjusterInfo.adjusterName)}
              </Typography>
            </span>
          )}

          <Stack spacing={0}>
            <Typography
              sx={{
                ...theme.custom.styles.adjusterNameStyle,
                marginLeft: '5rem',
                marginTop: '-4rem',
                overflow: 'hidden',
                'white-space': 'nowrap',
                'text-overflow': 'ellipsis',
              }}
            >
              {props.adjusterInfo.adjusterName}
            </Typography>

            <Stack>
              {props.adjusterInfo.adjusterEmail && (
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    handleEmailClick();
                  }}
                  sx={{
                    ...theme.custom.styles.adjusterCardPhoneNumberAndEmailStyle,
                    textAlign: 'start',
                    marginTop: '1rem',
                  }}
                >
                  Email
                </Link>
              )}
            </Stack>

            <Stack>
              {props.adjusterInfo.adjusterPhoneNumber && (
                <Typography>
                  <Link
                    underline="none"
                    sx={{
                      ...theme.custom.styles.adjusterCardPhoneNumberAndEmailStyle,
                      marginTop: '-0.5rem',
                    }}
                    href={`tel:${getPrettyPhoneNumber(props.adjusterInfo.adjusterPhoneNumber)}`}
                  >
                    {getPrettyPhoneNumber(props.adjusterInfo.adjusterPhoneNumber)}
                  </Link>
                </Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
